export default __webpack_public_path__ + "static/media/peacock.f2504986.jpeg";